module.exports = __webpack_public_path__ + "img/strong-app.904f247a.png";